import type { AnimationItem, AnimationSegment } from 'lottie-web';

import type { SyncingState } from 'src/modules/syncing';

import { FileStatus } from '../../types';

const fileStatusToSyncStatus: Record<string, SyncingState> = {
  [FileStatus.FILE_OK]: 'SYNCED',
  [FileStatus.FILE_EXPORT_OK]: 'SYNCED',
  [FileStatus.FILE_UPLOADING]: 'SYNCING',
  [FileStatus.FILE_EXPORTING]: 'SYNCING',
  [FileStatus.FILE_UPLOAD_ERROR]: 'ERROR',
  [FileStatus.FILE_EXPORT_ERROR]: 'ERROR',
};

export const convertFileStatusToSyncStatus = (status: string): SyncingState =>
  fileStatusToSyncStatus[status] || 'ERROR';

export enum AnimationKeyFrames {
  START = 1,
  START_END = 117,
  PARSING = 118,
  PARSING_END = 213,
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  SUCCESS = 213,
  END = 300,
}

export enum AnimationTimings {
  UPLOADING = 1700,
  PARSING = 1380,
  SUCCESS = 1450,
  LAST_FRAME = 500,
}

export const ANIMATION_SEGMENT_UPLOADING = [
  AnimationKeyFrames.START,
  AnimationKeyFrames.START_END,
] as AnimationSegment;

export const ANIMATION_SEGMENT_PARSING = [
  AnimationKeyFrames.PARSING,
  AnimationKeyFrames.PARSING_END,
] as AnimationSegment;

export const ANIMATION_SEGMENT_SUCCESS = [
  AnimationKeyFrames.SUCCESS,
  AnimationKeyFrames.END,
] as AnimationSegment;

export enum AnimationState {
  UPLOADING = 'UPLOADING',
  PARSING = 'PARSING',
  SUCCESS = 'SUCCESS',
}

export const playAnimation = ({
  animationInstance,
  animationState,
}: {
  animationInstance: { current: AnimationItem };
  animationState?: AnimationState;
}) => {
  if (animationState) {
    if (animationState === AnimationState.UPLOADING) {
      animationInstance.current.playSegments(ANIMATION_SEGMENT_UPLOADING, true);
    }
    if (animationState === AnimationState.PARSING) {
      animationInstance.current.playSegments(ANIMATION_SEGMENT_PARSING, true);
    }
    if (animationState === AnimationState.SUCCESS) {
      animationInstance.current.playSegments(ANIMATION_SEGMENT_SUCCESS);
    }
  }
};
